import { LocaleMatch } from '../routes';
import { ClientSafeTenant } from '../../../helpcenter-data';
import { helpcenterApi } from '../../../api';
import { decodeClientSearchTerm } from '../../components-for-sections/search-input/search-input';
import { ContentFilters } from '../../utils/sdk/domain';
import { INTERNAL_DOCS_FETCH_COUNT, SEARCH_RES_PAGE_SIZE } from '../../section-rendering/specific-section-renderer';
import { isInternalDocsEnabledTenant } from '../../../common/utils';

export const searchArticleResults = (
	brandId: string,
	locale: string,
	searchTerm: string,
	page: number,
	sdkContentFilters?: ContentFilters,
	tenantId?: string,
	baseUrl?: string,
) => {
	const maybeContentFilters = sdkContentFilters || {};

	if (isInternalDocsEnabledTenant(tenantId)) {
		return helpcenterApi
			.getInternalRelatedDocs({
				locale,
				query: searchTerm
			})
			.then((articleList) => ({
				articles: articleList.data,
				itemsCount: articleList.itemsCount,
				search: {
					term: searchTerm,
					page: page
				},
				page: 1
			}));
	}

	return helpcenterApi
		.searchArticles(
			{
				brandId,
				locale,
				text: searchTerm,
				page: page > 0 ? page : 1,
				pageSize: SEARCH_RES_PAGE_SIZE,
				spellcheck: true,
				...maybeContentFilters
			},
		)
		.then((articleList) => ({
			articles: articleList.data,
			itemsCount: articleList.itemsCount,
			search: {
				term: searchTerm,
				page: page
			},
			page: page > 0 ? page : 1
		}));
}
const loadDataClient = (
	params: LocaleMatch,
	tenant: ClientSafeTenant,
	location: any,
	initialData: any,
	baseUrl?: string,
	sdkContentFilters?: ContentFilters
) => {
	const isInternalDocsEnabled = isInternalDocsEnabledTenant(tenant.id);

	return Promise.all([
		searchArticleResults(
			tenant.brandId,
			params.locale,
			decodeClientSearchTerm(new URLSearchParams(location.search).get('term') || ''),
			Number(new URLSearchParams(location.search).get('page') || 1),
			sdkContentFilters,
			isInternalDocsEnabled ? tenant.id : undefined,
			isInternalDocsEnabled ? baseUrl : undefined,
		),
	]);
};

export default loadDataClient;
